import { Injectable } from '@angular/core';
import { CommonConstant } from './constants';
import { CommonUtility } from './utility';

@Injectable({ providedIn: 'root' })
export class UserAuthService {

    saveToken(token: string): void {
        sessionStorage.setItem(CommonConstant.token, token);
    }

    saveOrgCode(orgCode: string): void {
        sessionStorage.setItem(CommonConstant.orgCode, orgCode);
    }

    saveSchoolName(schoolName: string): void {
        sessionStorage.setItem(CommonConstant.school, schoolName);
    }

    saveEmployeeName(employeeName: string): void {
        sessionStorage.setItem(CommonConstant.employeeName, employeeName);
    }

    saveEmployeeId(employeeId: any): void {
        sessionStorage.setItem(CommonConstant.employeeId, employeeId);
    }

    saveStudentProfileId(studentId: any): void {
        sessionStorage.setItem(CommonConstant.studentProfileId, studentId);
    }

    saveAppName(appName: string): void {
        sessionStorage.setItem(CommonConstant.appName, appName);
    }

    saveUserName(userName: string): void {
        sessionStorage.setItem(CommonConstant.userName, userName);
    }

    saveSupportSessionId(sessionId: string): void {
        if (sessionId) {
            sessionStorage.setItem(CommonConstant.supportSessionId, sessionId);
        } else {
            sessionStorage.removeItem(CommonConstant.supportSessionId);
        }
    }

    saveImpersonatedSchool(school: any): void {
        if (school) {
            sessionStorage.setItem(CommonConstant.impersonatedSchool, JSON.stringify(school));
        } else {
            sessionStorage.removeItem(CommonConstant.impersonatedSchool);
        }
    }

    getToken(): string | null {
        return sessionStorage.getItem(CommonConstant.token) || this.getTokenFromUrl();
    }

    getTokenFromUrl(): string | null {
        return new URLSearchParams(window.location.search).get('token');
    }

    getOrgCode(): string | null {
        return sessionStorage.getItem(CommonConstant.orgCode)
            || new URLSearchParams(window.location.search).get('code');
    }

    getSchoolName(): string | null {
        return sessionStorage.getItem(CommonConstant.school);
    }

    getEmployeeName(): string | null {
        return sessionStorage.getItem(CommonConstant.employeeName);
    }

    getEmployeeId(): string | null {
        return sessionStorage.getItem(CommonConstant.employeeId);
    }

    getStudentProfileId(): string | null {
        return sessionStorage.getItem(CommonConstant.studentProfileId);
    }

    getAppName(): string | null {
        return sessionStorage.getItem(CommonConstant.appName);
    }

    getUserName(): string | null {
        return sessionStorage.getItem(CommonConstant.userName);
    }

    getSupportSessionId(): string | null {
        return sessionStorage.getItem(CommonConstant.supportSessionId);
    }

    getImpersonatedSchool(): any {
        const school = sessionStorage.getItem(CommonConstant.impersonatedSchool);
        return CommonUtility.isEmpty(school) ? null : JSON.parse(school!);
    }

    isLoggedIn(): boolean {
        return !CommonUtility.isNull(this.getToken());
    }

    logout(): void {
        sessionStorage.clear();
    }
}
